/**
 * Component - v2.1.0
 */

// Libraries
import React from 'react';

// Supermove
import {useResponsive} from '@supermove/hooks';

// Components
import {Modal} from '..';
import Popover, {PopoverPlacementType} from '../Popover';
import Styled from '../Styled';

const ModalContainer = Styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;

interface ResponsivePopoverProps {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  reference: React.RefObject<HTMLElement>;
  isClosableOutside?: boolean;
  placement?: PopoverPlacementType;
  offset?: [number, number];
  arrow?: boolean;
  onComponentDidHide?: () => void;
}

const ResponsivePopover = ({
  children,
  isOpen,
  handleClose,
  handleOpen,
  reference,
  isClosableOutside,
  placement,
  offset,
  arrow,
  onComponentDidHide,
}: ResponsivePopoverProps) => {
  const responsive = useResponsive();

  if (!responsive.desktop) {
    return (
      <Modal.Content isOpen={isOpen} onClose={handleClose}>
        <ModalContainer>{children}</ModalContainer>
      </Modal.Content>
    );
  }
  return (
    <Popover
      handleOpen={handleOpen}
      handleClose={handleClose}
      reference={reference}
      isOpen={isOpen}
      children={children}
      isClosableOutside={isClosableOutside}
      placement={placement}
      offset={offset}
      arrow={arrow}
      onComponentDidHide={onComponentDidHide}
    />
  );
};

export default ResponsivePopover;
